import Cleave from 'cleave.js'
import { select as $, remove, selectAll } from './dom'
import DOMPurify from 'dompurify';

export class InsuranceForm {
  constructor(el, appointmentId) {
    this.body = $('[data-component="form-body"]', el)
    this.fields = $('[data-component="form-fields"]', el, 'fieldset')
    this.toggle = $('[data-component="form-toggle"]', el, 'button')
    this.selfPay = selectAll('[data-component="self-pay"]', el)
    this.subscriberBody = $('[data-component="subscriber-body"]', el)
    this.subscriberFields = $(
      '[data-component="subscriber-fields"]',
      el,
      'fieldset',
    )
    this.nameField = $(
      '#telemedicine_intakes_v2_insurance_form_intake_insurance_subscriber_full_name',
      this.subscriberFields,
    )
    this.dobField = $('#subscriber_dob', this.subscriberFields)
    this.subscriberInfo = $('[data-component="subscriber-info"]', el)
    this.dob = document.querySelector('#subscriber_dob')
    this.insuranceProvider = $(
      '#telemedicine_intakes_v2_insurance_form_intake_insurance_provider',
      el,
    )
    this.insurancePlan = $(
      '#telemedicine_intakes_v2_insurance_form_intake_insurance_plan',
      el,
    )
    this.subscriberId = $(
      '#telemedicine_intakes_v2_insurance_form_intake_insurance_subscriber_id',
      el,
    )
    this.copay = $('#copay-input', el)
    this.cardFrontInput = $(
      '#telemedicine_intakes_v2_insurance_form_intake_insurance_card_front',
      el,
    )
    this.cardFrontLabel = $('#card-front-label', el)

    this.cardBackInput = $(
      '#telemedicine_intakes_v2_insurance_form_intake_insurance_card_back',
      el,
    )
    this.cardBackLabel = $('#card-back-label', el)

    this.cardFrontFileName = $('#card-front-file-name', el)
    this.cardBackFileName = $('#card-back-file-name', el)

    this.cardFrontFileName.innerHTML = ''
    this.cardBackFileName.innerHTML = ''

    this.useInsuranceOnFile = $('#use-iof', el)
    this.updateInsuranceOnFile = $('#update-iof', el)

    this.toggle.addEventListener('click', this.toggleFields.bind(this))
    for (let i = 0; i < this.selfPay.length; i++) {
      this.selfPay[i].addEventListener('click', this.toggleBody.bind(this))
    }
    this.subscriberInfo.addEventListener(
      'click',
      this.toggleSubscriber.bind(this),
    )

    this.dob.addEventListener('input', this.handleInput.bind(this))

    new Cleave(this.dob, {
      date: true,
      datePattern: ['m', 'd', 'Y'],
    })
    this.cardFrontInput.addEventListener('change', e =>
      this.onUploadFileChange(e, this.cardFrontFileName, this.cardFrontLabel),
    )
    this.cardBackInput.addEventListener('change', e =>
      this.onUploadFileChange(e, this.cardBackFileName, this.cardBackLabel),
    )

    if (this.nameField.value || this.dobField.value) {
      this.fields.disabled = false
      this.toggle.innerHTML = 'Use insurance on file'
    }
    if (this.subscriberInfo.checked) {
      this.fields.disabled = false
      remove(this.subscriberFields)
    }
    this.appointmentId = $('.intake-layout').getAttribute('appointment-id')

    this.useInsuranceOnFile.addEventListener('click', e => {
      document.querySelector('#insurance-fields').classList.add('hidden')
      this.nameField.required = false
      this.dobField.required = false
      this.insuranceProvider.required = false
      this.insurancePlan.required = false
      this.subscriberId.required = false
      this.copay.required = false
    })

    this.updateInsuranceOnFile.addEventListener('click', e => {
      document.querySelector('#insurance-fields').classList.remove('hidden')
      this.nameField.required = true
      this.dobField.required = true
      this.insuranceProvider.required = true
      this.insurancePlan.required = true
      this.subscriberId.required = true
      this.copay.required = true
    })
  }

  get selfPaying() {
    let radios = selectAll('[data-component="self-pay"]:checked', document)
    if (radios.length > 0) {
      return radios[0].value == 'true'
    } else {
      return false
    }
  }

  get subscriberDetail() {
    return this.subscriberInfo.checked
  }

  toggleFields() {
    if (this.fields.disabled) {
      this.toggle.innerHTML = 'Use insurance on file'
    } else {
      this.toggle.innerHTML = 'Update Insurance'
    }
    this.fields.disabled = !this.fields.disabled
  }

  toggleBody() {
    this.body.disabled = this.selfPaying

    /**
     * If we are not updating these fields, Safari needs them to be removed
     * from the document, otherwise form validation will trigger.
     */
    if (this.selfPaying) {
      remove(this.fields)
    } else {
      this.body.appendChild(this.fields)
    }
  }

  toggleSubscriber() {
    this.subscriberFields.disabled = this.subscriberDetail
    if (this.subscriberDetail) {
      remove(this.subscriberFields)
    } else {
      this.subscriberBody.appendChild(this.subscriberFields)
    }
  }

  handleInput() {
    if (Date.parse(this.dob.value) > Date.now()) {
      this.dob.setCustomValidity("DOB must be before today's date")
    } else {
      this.dob.setCustomValidity('')
    }
  }

  onUploadFileChange(e, filename, label) {
    let removeLink = `<span class="remove-link" onClick="document.getElementById('${e.currentTarget.id
      }').value = '';document.getElementById('${e.currentTarget.id
      }').dispatchEvent(new Event('change', { 'bubbles': true }))">x</span>`

    if (e.currentTarget.value == '') {
      filename.innerHTML = ''
      label.style.display = "inline-block"
    } else {
      filename.innerHTML = DOMPurify.sanitize(e.currentTarget.value.split('\\').pop() + removeLink)
      label.style.display = "none"
    }
  }
}
